import React from 'react';
import { CheckCircle2, BookOpen } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const tomos = [{
  emoji: '📘',
  title: 'Tomo 1 — Fundamentos y Protocolo de Seguridad',
  desc: 'Herramientas correctas, Protocolo Voltaje Cero y la base que hace que cada reparación sea segura.'
}, {
  emoji: '📗',
  title: 'Tomo 2 — Batería, BMS y Carga Inteligente',
  desc: 'Diagnóstico del pack, balanceo profundo y cómo duplicar la vida útil de tu batería con hábitos de carga.'
}, {
  emoji: '📙',
  title: 'Tomo 3 — Motor: Rulemanes, Hall y Estanqueidad',
  desc: 'Diagnosticá y reemplazá rulemanes. Identificá sensores Hall muertos. Sellá el motor contra el agua.'
}, {
  emoji: '📕',
  title: 'Tomo 4 — Placa Madre y Firmware',
  desc: 'Diagnóstico de MOSFETs, actualización segura de firmware y calibración del giroscopio.'
}, {
  emoji: '📓',
  title: 'Tomo 5 — Neumáticos y Carrocería',
  desc: 'Cambio de cubierta, presión exacta para tu peso y reparación de plásticos de carcasa.'
}, {
  emoji: '📔',
  title: 'Tomo 6 — Diccionario de Errores y Alarmas',
  desc: 'Diagnóstico por código, sonido y comportamiento. La guía de emergencia que llevás en el celular.'
}];
const features = ['Paso a paso con diagramas explicativos', 'Semáforo verde/amarillo/rojo en cada diagnóstico', 'Protocolos de seguridad antes de cada intervención', 'Precios y proveedores en pesos argentinos 2026', 'Compatible con Begode, Kingsong, Inmotion, Sherman y más'];
export function ProductBreakdown() {
  return <AnimatedSection className="py-24 bg-brand-surface border-y border-brand-border" data-id="element-221">
      <div className="container mx-auto px-4 md:px-6" data-id="element-222">
        <div className="text-center mb-16" data-id="element-223">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-yellow/10 mb-6" data-id="element-224">
            <span className="text-4xl" data-id="element-225">🏆</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-226">
            MEGA PACK MONOCICLO ELÉCTRICO
          </h2>
          <p className="text-xl text-brand-yellow font-medium mb-10" data-id="element-227">
            6 Tomos + 6 Bonos — 300 páginas. Todo resuelto.
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/kFX2qKEtscz8SaeeXZeG26/mockup_monociclo.png" alt="Mega Pack Monociclo Eléctrico" className="w-full max-w-md mx-auto mb-4 drop-shadow-[0_0_30px_rgba(250,204,21,0.1)]" data-id="element-228" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-229">
          {tomos.map((tomo, index) => <div key={index} className="bg-brand-dark border border-brand-border rounded-xl p-6 hover:border-brand-yellow/50 transition-colors" data-id="element-230">
              <div className="text-4xl mb-4" data-id="element-231">{tomo.emoji}</div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-232">
                {tomo.title}
              </h3>
              <p className="text-zinc-400" data-id="element-233">{tomo.desc}</p>
            </div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-brand-dark border border-brand-border rounded-xl p-8" data-id="element-234">
          <h4 className="text-2xl font-bold mb-6 text-center flex items-center justify-center gap-2" data-id="element-235">
            <BookOpen className="text-brand-yellow" data-id="element-236" />
            ¿Qué incluye exactamente?
          </h4>
          <ul className="space-y-4" data-id="element-237">
            {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-238">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0" data-id="element-239" />
                <span className="text-lg text-zinc-300" data-id="element-240">{feature}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </AnimatedSection>;
}